import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { CustomHeader } from '@vio/shared/src/whiteLabel/CustomHeader';
import { DesktopHeader } from 'components/DesktopHeader';
import { getIsSyntheticTest } from 'modules/meta/selectors';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { BaseHomeDesktopHeader } from './BaseHomeDesktopHeader';
import { BaseHomeMobileHeader } from './BaseHomeMobileHeader';
import { FixedHeader } from './FixedHeader';
const StaticHeaderWrapper = /*#__PURE__*/styled('div')({
  name: "StaticHeaderWrapper",
  class: "smnjxq2",
  propsAsIs: false
});
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1m80geu",
  propsAsIs: false
});
interface Props {
  isStickyHeaderVisible?: boolean;
}
export const Header: React.FC<Props> = ({
  isStickyHeaderVisible
}) => {
  const {
    isMobile
  } = useDeviceLayout();
  const isSyntheticTest = useSelector(getIsSyntheticTest);
  const {
    brandHasAlternativeSearchForm,
    brandIsVio,
    brandHasCustomHeader,
    brandCode
  } = useBrand();
  if (brandHasCustomHeader) {
    return <HeaderWrapper>
        <CustomHeader brandCode={brandCode} isFloating={!isMobile} />
      </HeaderWrapper>;
  }
  if (!isMobile && brandHasAlternativeSearchForm) return <HeaderWrapper>
        <DesktopHeader isFixed />
      </HeaderWrapper>;
  return <>
      <StaticHeaderWrapper>
        {isMobile ? <BaseHomeMobileHeader /> : <BaseHomeDesktopHeader showSupportButton={brandIsVio} />}
      </StaticHeaderWrapper>

      {brandIsVio && !isSyntheticTest && <FixedHeader isVisible={isStickyHeaderVisible} />}
    </>;
};

require("./Header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Header.tsx");